<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2">
        <i class="bi bi-chevron-left align-middle"></i>
      </div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Mis Productos</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-0 p-md-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">
        @if (error()) {
          <div class="alert alert-danger mt-0" role="alert">
            <small>{{ error() }}</small>
          </div>
        }

        @if (message()) {
          <div class="alert alert-success mt-0" role="alert">
            <small>{{ message() }}</small>
          </div>
        }

        <div class="d-grid mt-0 mb-0 pb-0">
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0 mb-5"
            [routerLink]="['/my-account-producto']"
          >
            Agregar nuevo producto
          </button>
        </div>

        <span class="p-0 m-0">
          <b>Productos ({{ productos().length }})</b>
        </span>

        @for (producto of productos(); track producto.id) {
          <div class="producto-card mt-3 form-switch">

            @if (producto.x_img_producto) {
              <img
                class="producto-image"
                [src]="API_URI + 'uploads/images/' + producto.x_img_producto"
                [alt]="producto.x_nombre"
              />
            } @else {
              <div class="producto-image-placeholder">
                <i class="bi bi-box-seam"></i>
              </div>
            }

            <a
              class="text-decoration-none text-dark flex-grow-1 overflow-hidden"
              [routerLink]="['/my-account-edit-producto/' + producto.id]"
            >
              <div class="producto-title text-truncate">
                {{ producto.x_nombre }}
              </div>

              @if (producto.x_descripcion) {
                <div class="producto-description">
                  {{ producto.x_descripcion }}
                </div>
              }

              <div class="producto-meta">

                @if (producto.n_precio) {
                  <span class="producto-price">
                    $ {{ producto.n_precio | number:'1.0-0' }}
                  </span>
                }

                @if (producto.n_porcentaje_descuento) {
                  <span class="producto-discount">
                    -{{ producto.n_porcentaje_descuento }}%
                  </span>
                }

              </div>

              @if (producto.x_sku) {
                <div class="producto-sku">
                  SKU: {{ producto.x_sku }}
                </div>
              }
            </a>

            <div class="col-2">
              <a
                class="producto-action"
                [routerLink]="['/my-account-edit-producto/' + producto.id]"
              >
                <i class="bi bi-pencil"></i>
              </a>
            </div>

            <div class="col-auto">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'producto-activo-' + producto.id"
                [checked]="producto.b_activo"
                [disabled]="loading()"
                (change)="activarDesactivar(producto, $any($event.target).checked)"
              />
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
